import { NetworkResource } from "@models/networkResource";
import { httpRequest } from "../../../http";

import { NetworkResourceSerializer } from "@models/serializers/networkResourceSerializer";

export class CommandCreateNetworkResource {
  async run(payload: NetworkResource): Promise<NetworkResource> {
    try {
      const response = await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/`,
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      return this.deserialize(response);
    } catch (error) {
      console.error("Error creating network resource:", error);
      throw error;
    }
  }

  private deserialize(data: any): NetworkResource {
    const serializer = new NetworkResourceSerializer();
    return serializer.deserialize(data);
  }
}
